import React from 'react';
import { InvitedJobsSearchProvider } from '../../../context/InvitedJobsSearchContext';
import InvitedJobsContent from './InvitedJobsContent';
import { useAppSelector } from '../../../redux/store';
import { useSubscriptionAccess } from '../../../components/Subscription/SubscriptionAccessProvider';
import { PrimaryButton } from '../../../components/Button/PrimaryButton';

const InvitedJobs = () => {
  const entitlements = useAppSelector(state => state.subscription.entitlements);
  const { requireFeature } = useSubscriptionAccess();
  return (
    <InvitedJobsSearchProvider>
      {entitlements && !entitlements.canReceiveJobInvites && <section style={{ padding: 16 }}>
        <p>Your current plan does not include receiving new job invitations. Existing invitations remain available.</p>
        <PrimaryButton click={() => { void requireFeature('canReceiveJobInvites'); }}>View invitation access</PrimaryButton>
      </section>}
      <InvitedJobsContent />
    </InvitedJobsSearchProvider>
  );
};

export default InvitedJobs;
